









































































































import { Component, Vue, Prop } from "vue-property-decorator";
import qrcodeModal from "./gameCom/qrcodeModal.vue";
import showDownload from "./gameCom/showDownload.vue";
import qs from "@/components/queSheng.vue";

@Component({
  components: { qrcodeModal, showDownload, qs },
})
export default class Home extends Vue {
  public activeIndex = 0; // 轮播index
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public detail;
  @Prop({type: Boolean, default: false}) public publicityShow;
  // 评分
  public toNum(num) {
    num == 0 ? (num = "评分过少") : (num = num);
    return num;
    // return Number(num).toFixed(1);
  }
  // 点击手机版
  public async showQrcode() {
    const $qrcodeModal: any = this.$refs.qrcodeModal;
    $qrcodeModal.show();
  }
  // 电脑版
  public async showDownload() {
    const res = await this.$fn.getGameLinks();
    this.showDownloads(res.pc_down_url)
  }
  public showDownloads(url) {
    const $showDownload: any = this.$refs.showDownload;
    $showDownload.show(this.detail, url);
  }
  // 点击轮播导航
  public selectSlider(i) {
    this.activeIndex = i;
    this.qihuan();
  }
  // 轮播左箭头
  public prev() {
    if (this.activeIndex == 0) {
      this.activeIndex = this.detail.publicity.length - 1;
    } else {
      this.activeIndex--;
    }
    this.qihuan();
  }
  // 轮播右箭头
  public next() {
    if (this.activeIndex == this.detail.publicity.length - 1) {
      this.activeIndex = 0;
    } else {
      this.activeIndex++;
    }
    this.qihuan();
  }
  // 切换效果
  public qihuan() {
    // 获取#sliderBox
    const sty: any = document.getElementById("sliderBox");
    // 获取轮播长度
    const len = this.detail.publicity.length - 1;
    // 如果是第一张
    if (this.activeIndex < 3) {
      sty.style.marginLeft = "0px";
    }
    // 如果img长度大于4张 保持中间
    if (len - this.activeIndex >= 3 && this.activeIndex >= 3) {
      sty.style.marginLeft = "-" + (this.activeIndex - 3) * 109 + "px";
    }
    // 如果是倒数第三张，显示完整
    if (len - this.activeIndex == 2) {
      const str = (this.activeIndex - 3) * 109;
      sty.style.marginLeft = "-" + (str + 11 - 109) + "px";
    }
    // 如果是倒数第二张，显示完整
    if (len - this.activeIndex == 1) {
      const str = (this.activeIndex - 4) * 109;
      sty.style.marginLeft = "-" + (str + 11 - 109) + "px";
    }
    // 如果是最后一张，显示完整
    if (len - this.activeIndex == 0) {
      const str = (this.activeIndex - 5) * 109;
      sty.style.marginLeft = "-" + (str + 11 - 109) + "px";
    }
  }
  // 点击前往交易行
  public goTransaction() {
    if (!this.$fn.cookies.getToken()) {
      (this as any).$toast(true);
      return false;
    }
    this.$router.push("/transaction")
  }
  // 点击前往充值
  public toRecharge() {
    if (!this.$fn.cookies.getToken()) {
      (this as any).$toast(true);
      return false;
    }
    for (const i in this.detail.lately_games) {
      if (true) {
        const element = this.detail.lately_games[i];
        if (element.box_game_id == this.detail.box_game_id) {
          this.$router.push({
            path: "/gameRecharge",
            query: {
              id: this.detail.box_game_id,
            },
          });
          return false;
        }
      }
    }
    this.$router.push({
      path: "/gameRecharge",
      query: {
        id: this.detail.box_game_id,
        name: this.detail.game_name,
      },
    });
  }
}
